export enum BrevoResponseCodesEnum {
  NOT_FOUND = 'document_not_found',
}
